import { TemplateTextarea } from "@components";
import { useWatch } from "react-hook-form";
import { SMS_SOFT_LIMIT, SMS_HARD_LIMIT } from "./templateUtils";

const SmsEditor = ({ control, errors }) => {
  const smsText = useWatch({ control, name: "smsText" }) || "";
  const charCount = smsText.length;
  const overLimit = charCount > SMS_SOFT_LIMIT;
  const overBy = charCount - SMS_SOFT_LIMIT;

  return (
    <div className="w-full flex flex-col items-center pb-8 pt-6">
      <div className="w-full max-w-xl px-6">
        <div className="bg-zinc-100 rounded-3xl max-w-[70%] p-4">
          <TemplateTextarea
            name="smsText"
            control={control}
            displayName="SMS message"
            placeholder="Type your SMS message..."
            invalid={!!errors?.smsText}
            borderless
            maxLength={SMS_HARD_LIMIT}
            validate={(val) => {
              if (val && val.length > SMS_SOFT_LIMIT)
                return `SMS exceeds ${SMS_SOFT_LIMIT} character limit`;
              return true;
            }}
            className="text-sm"
          />
          <br />
          <span className="text-xs text-blue-400">
            https://webpay.ontik.io/pay/id
          </span>
        </div>
        {overLimit && (
          <p className="mt-2 text-xs text-red-500">
            {SMS_SOFT_LIMIT} character limit. You are {overBy}{" "}
            {overBy === 1 ? "character" : "characters"} over.
          </p>
        )}
      </div>
    </div>
  );
};

export default SmsEditor;
